import { render, staticRenderFns } from "./tasks-modal-list-item-title.vue?vue&type=template&id=0a0fc06e&scoped=true"
import script from "./tasks-modal-list-item-title.vue?vue&type=script&lang=js"
export * from "./tasks-modal-list-item-title.vue?vue&type=script&lang=js"
import style0 from "./tasks-modal-list-item-title.vue?vue&type=style&index=0&id=0a0fc06e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0fc06e",
  null
  
)

/* custom blocks */
import block0 from "./tasks-modal-list-item-title.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports